import styled from 'styled-components'
import {StyledButton} from './StyledTypeDefinitions'
import {Colors, FontSize, FontWeights, LineHeight} from './Constants'
import {backArrow, forwardArrow} from './Links'

export const PlainStyledButton: StyledButton = styled.button`
  cursor: pointer;
  font-size: ${FontSize.Body};

  &:focus {
    outline: 0;
  }
`

export const PrimaryStyledButton = styled(PlainStyledButton)`
  display: block;
  margin-left: auto;
  margin-right: auto;
  height: 100%;
  min-height: 50px;
  width: 100%;
  max-width: 384px;

  border: 1px solid ${Colors.Primary};
  border-radius: 8px;

  font-weight: ${FontWeights.Bold};
  color: ${Colors.Surface};
  background-color: ${Colors.Primary};

  box-shadow: 0 2px 0 0 ${Colors.PrimaryVariant};

  :active {
    background-color: ${Colors.PrimaryActive};
    box-shadow: none;
  }

  :disabled  {
    pointer-events: none;
    border: none;
    background-color: ${Colors.AccentLight};
    box-shadow: none;
  }

`

export const SubmitPrimaryButton = styled(PlainStyledButton)`
  color: ${Colors.Surface};
  background-color: ${Colors.Primary};

  border: none;
  border-radius: 4px;
  line-height: 1.5;
  padding: 8px 15px;

  :active {
    background-color: ${Colors.PrimaryActive};
    box-shadow: none;
  }

  :disabled {
    pointer-events: none;
    border: none;
    background-color: ${Colors.AccentLight};
    box-shadow: none;
  }
`

export const DefaultStyledButton = styled(PlainStyledButton)`
  display: block;
  margin-left: auto;
  margin-right: auto;
  height: 100%;
  min-height: 50px;
  width: 100%;
  max-width: 384px;

  font-size: ${FontSize.Middle};
  font-weight: ${FontWeights.Normal};
  border: 1px solid ${Colors.SecondaryActive};
  background: ${Colors.SecondaryActive};
  box-shadow: 0px 2px 0px rgba(112, 112, 112, 0.5);
  border-radius: 8px;
  color: ${Colors.Body};

  :active {
    background: linear-gradient(0deg, rgba(112, 112, 112, 0.75), rgba(112, 112, 112, 0.75)), #D9D9D9;
    box-shadow: none;
  }
  :disabled  {
    background-color: ${Colors.AccentLight};
  }
`

export const UnstyledLinkStyledButton: StyledButton = styled.button`
  cursor: pointer;
  color: ${Colors.Body};
  font-size: ${FontSize.Body};
  line-height: ${FontSize.Body};
  font-weight: ${FontWeights.Normal};
  outline: none;
  text-decoration: none;
  -webkit-tap-highlight-color: rgba(0,0,0,0);
  background-color: transparent;
  padding: 0 0 0 0;
  display: block;
  box-sizing: border-box;
  border: none;
  width: auto;
`

export const PlainLinkStyledButton = styled(UnstyledLinkStyledButton)`
  color: ${Colors.Primary};
`

export const PlainLinkStyledBackButton = styled(PlainLinkStyledButton)`
  position: relative;
  padding-left: 15px;
  text-align: left;
  margin: 0;

  :before {
    ${backArrow};
  }
`
export const PlainForwardLinkStyledButton = styled(PlainLinkStyledButton)`
  position: relative;
  padding-right: 15px;
  text-align: right;
  margin: 0;

 :after {
    ${forwardArrow};
  }
`

export const CenterPlainLinkStyledButton = styled(PlainLinkStyledButton)`
  display: block;
  margin-left: auto;
  margin-right: auto;
  max-width: 384px;
`

export const SmallPlainLinkStyledButton = styled(PlainLinkStyledButton)`
  margin: 0;
  display: inline-block;
  font-size: ${FontSize.Body};
  line-height: ${LineHeight.Basic};
  text-align: left;
`

// SecondaryButton
export const SecondaryButton = styled(PlainStyledButton)`
  display: block;
  margin-left: auto;
  margin-right: auto;
  height: 50px;
  width: 100%;
  max-width: 384px;

  border: 1px solid rgba(0, 112, 176, 0.5);
  border-radius: 8px;

  color: ${Colors.Primary};
  background-color: ${Colors.Surface};


  :active {
    background-color: ${Colors.SecondaryActive};
    box-shadow: none;
  }

  :disabled  {
    color: ${Colors.AccentLight};
    pointer-events: none;
    border: 1px solid ${Colors.AccentLight};
    background-color: ${Colors.Surface};
    box-shadow: none;
  }
`

export const StyledSecondaryButton = styled(SecondaryButton)`
  background-color: transparent;
`
